/**
 * @file Contains the license agreement content JSX
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import React from 'react'

const licenseAgreementContent = props => (
    <div className="col-sm-12 col-lg-9">
        <h2 className="text-large">Legal Notices and Terms of Use</h2>
        <p>
            <em>Last modified: April 18, 2019</em>
        </p>
        <p>
            Welcome to the MicroStrategy website (the "Site"). MicroStrategy
            Incorporated ("MicroStrategy") makes content, materials,
            information, software, products and services available on this Site,
            subject to the following terms and conditions. By using the Site,
            you agree to follow and be bound by the following terms and
            conditions concerning your use of the Site ("Terms of Use").
            MicroStrategy reserves the right to change these terms and
            conditions, as well as the products, services, prices, and programs
            mentioned on this Site at any time, in its sole discretion, without
            notice. You are responsible for reviewing these Terms of Use often
            enough to stay current of any changes. MicroStrategy will endeavor
            to notify you of any material changes by posting notice of such
            changes on the Site. Your continued use of any part of the Site
            after MicroStrategy posts such changes to the Terms of Use
            (regardless of whether MicroStrategy has specifically notified you
            of such changes) shall indicate your acknowledgment of such changes
            and agreement to be bound by the revised Terms of Use. If you do not
            agree to all of the Terms of Use, you should not access, visit or
            participate in the Site. MicroStrategy reserves the right to seek
            all remedies available by law and in equity for any violation of
            these Terms of Use. If you breach any of the Terms of Use, your
            authorization to use the Site automatically terminates and you agree
            to immediately destroy any material you obtained from the Site (or
            derived from material you obtained from the Site). Any rights not
            expressly granted herein are reserved. Please note that these Terms
            of Use cover your use of the Site and do not necessarily cover your
            use of products accessed through the Site. MicroStrategy will not be
            liable to you or any third-party for any claims or actions arising
            or resulting from your use, visit, or participation in the Site and
            for any modification, suspension, or termination of the Site, or
            termination of your access to any of your accounts.
        </p>
        <h3 className="padding-top-30">
            Use of Forums and Public Communication
        </h3>
        <p>
            The Site may contain discussion group, bulletin board services, chat
            areas, news groups, forums, communities, and/or other message or
            communication facilities designed to enable you to communicate with
            others ("Communication Services"). You agree to use the
            Communication Services only to post, send and receive messages and
            material that are proper and, when applicable, consistent with
            MicroStrategy’s intended purpose for the particular Communication
            Service.
        </p>
        <p>
            By way of example, and not as a limitation, you agree that when
            using the Communication Services, you will not:
        </p>
        <ul>
            <li>
                Use the Communication Services in connection with surveys,
                contests, pyramid schemes, chain letters, junk email, spamming
                or any duplicative or unsolicited messages (commercial or
                otherwise).
            </li>
            <li>
                Defame, abuse, harass, stalk, threaten or otherwise violate the
                legal rights (such as rights of privacy and publicity) of
                others.
            </li>
            <li>
                Promote bigotry, racism, hatred or harm against any group or
                individual.
            </li>
            <li>
                Publish, post, upload, distribute or disseminate any
                inappropriate, false, misleading, profane, defamatory, obscene,
                indecent or unlawful topic, name, material or information.
            </li>
            <li>
                Upload, or otherwise make available, files that contain images,
                photographs, software or other material protected by
                intellectual property laws, including, by way of example, and
                not as limitation, copyright or trademark laws (or by rights of
                privacy or publicity) unless you own or control the rights
                thereto or have received all necessary consent to do the same.
            </li>
            <li>
                Use any material or information, including images or
                photographs, which are made available through the Communication
                Services in any manner that infringes any copyright, trademark,
                patent, trade secret, or other proprietary right of any party.
            </li>
            <li>
                Upload files that contain viruses, Trojan horses, worms, time
                bombs, cancelbots, corrupted files, or any other similar
                software or programs that may damage the operation of another"s
                computer or property of another.
            </li>
            <li>
                Do not post any instructions, software or other materials that
                would allow participants or third parties to harm other users’
                computers or inappropriately access software or websites.
            </li>
            <li>
                Engage in any commercial activity. You shall not distribute or
                otherwise publish any content containing a solicitation of
                funds, promotion, advertising, solicitation for goods or
                services, or other commercial matter. You agree not to solicit
                other users of the Site to use or join or become members of any
                commercial online or offline service or other organization. You
                agree not to collect or store personal data about other users.
            </li>
            <li>
                Download any file posted by another user of a Communication
                Service that you know, or reasonably should know, cannot be
                legally reproduced, displayed, performed, and/or distributed in
                such manner.
            </li>
            <li>
                Falsify or delete any copyright management information, such as
                author attributions, legal or other proper notices or
                proprietary designations or labels of the origin or source of
                software or other material contained in a file that is uploaded.
            </li>
            <li>
                Restrict or inhibit any other user from using and enjoying the
                Communication Services.
            </li>
            <li>
                Violate any code of conduct or other guidelines which may be
                applicable for any particular Communication Service.
            </li>
            <li>Do not misrepresent the source of anything you contribute.</li>
            <li>
                You are responsible and liable for all your activities while
                participating to the Site, including anything you contribute.
            </li>
            <li>
                Harvest or otherwise collect information about others, including
                e-mail addresses.
            </li>
            <li>Violate any applicable laws or regulations.</li>
            <li>
                Create a false identity for the purpose of misleading others.
            </li>
            <li>
                Use, download or otherwise copy, or provide (whether or not for
                a fee) to a person or entity any directory of users of the
                Communication Services or other user or usage information or any
                portion thereof.
            </li>
        </ul>
        <p>
            MicroStrategy has no obligation to monitor the Communication
            Services. However, MicroStrategy reserves the right to review
            materials posted to the Communication Services and to remove any
            materials in its sole discretion. MicroStrategy reserves the right
            to terminate your access to any or all of the Communication Services
            at any time, without notice, for any reason whatsoever.
        </p>
        <p>
            Information exchanged on the Site is not confidential. MicroStrategy
            reserves the right at all times to disclose any information as
            MicroStrategy deems necessary to satisfy any applicable law,
            regulation, legal process or governmental request, or to edit,
            refuse to post or to remove any information or materials, in whole
            or in part, in MicroStrategy"s sole discretion.
        </p>
        <p>
            Always use caution when giving out any personally identifiable
            information about yourself in any Communication Services.
            MicroStrategy does not control or endorse the content, messages or
            information found in any Communication Services.
        </p>

        <h3 className="padding-top-30">Termination of Use</h3>
        <p>
            You agree that MicroStrategy may, in its sole discretion, at any
            time terminate your access to the Site and any account(s) you may
            have in connection with the Site. Access to the Site may be
            monitored by MicroStrategy.
        </p>
        <h3 className="padding-top-30">
            Third Party Web Sites, Content, Products and Services
        </h3>
        <p>
            The Site may provide links to Web sites and access to content,
            products and services from third parties, which are not under the
            control of MicroStrategy. You agree that MicroStrategy is not
            responsible for third party content accessible through the Site,
            including opinions, advice, statements and advertisements, and
            understand that you bear all risks associated with the use of such
            content. MicroStrategy is providing these links to you only as a
            convenience, and the inclusion of any link does not imply
            endorsement by MicroStrategy of the Site and does not grant you any
            license to products or services available through those links. You
            should refer to the policies posted by other Web sites regarding
            privacy and other topics before you use them. When you access a non-
            MicroStrategy Web site, you do so at your own risk. The Site may
            mention third-party products and services for informational
            purposes. MicroStrategy makes no recommendations or endorsements
            about third-party products and services.
        </p>

        <h3 className="padding-top-30">DISCLAIMER</h3>
        <p>
            THIS SITE AND ANYTHING DESCRIBED ON THIS SITE IS SUBJECT TO CHANGE
            WITHOUT NOTICE. MICROSTRATEGY MAKES NO WARRANTIES OR COMMITMENTS
            CONCERNING THE AVAILABILITY OF FUTURE PRODUCTS, FEATURES OR VERSIONS
            THAT MAY BE PLANNED OR UNDER DEVELOPMENT OR ANY SPECIFICATIONS
            DESCRIBED ON THIS SITE. MICROSTRATEGY HAS NO SPECIAL RELATIONSHIP OR
            FIDUCIARY DUTY TO YOU.
        </p>
        <p>
            EXCEPT WHERE EXPRESSLY PROVIDED OTHERWISE, THE SITE, AND ALL
            CONTENT, MATERIALS, INFORMATION, SOFTWARE, PRODUCTS AND SERVICES
            PROVIDED ON THE SITE, ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE"
            BASIS. MICROSTRATEGY EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND,
            WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE
            IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NON-INFRINGEMENT.
        </p>
        <p>
            EXCEPT WHERE EXPRESSLY PROVIDED OTHERWISE, MICROSTRATEGY MAKES NO
            WARRANTY THAT: (A) THE SITE OR ANY CONTENT, MATERIALS, INFORMATION,
            SOFTWARE, PRODUCTS AND SERVICES OFFERED THROUGH THE SITE WILL MEET
            YOUR REQUIREMENTS; (B) THE SITE OR ANY CONTENT, MATERIALS,
            INFORMATION, SOFTWARE, PRODUCTS AND SERVICES OFFERED THROUGH THE
            SITE WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR
            ERROR-FREE BASIS; (C) THE RESULTS THAT MAY BE OBTAINED FROM THE USE
            OF THE SITE OR ANY SOFTWARE, PRODUCTS OR SERVICES OFFERED THROUGH
            THE SITE WILL BE ACCURATE OR RELIABLE; OR (D) THE QUALITY OF ANY
            CONTENT, MATERIALS, INFORMATION, SOFTWARE, PRODUCTS OR SERVICES
            PURCHASED OR OBTAINED BY YOU THROUGH THE SITE WILL MEET YOUR
            EXPECTATIONS. ANY CONTENT, MATERIALS, INFORMATION, PRODUCTS OR
            SOFTWARE DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE
            SITE IS USED AT YOUR OWN DISCRETION AND RISK. MICROSTRATEGY SHALL
            HAVE NO RESPONSIBILITY FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR
            LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY CONTENT,
            MATERIALS, INFORMATION, PRODUCTS OR SOFTWARE OR THE UPLOAD BY YOU OF
            ANY CONTENT, MATERIALS, INFORMATION, SOFTWARE, PRODUCTS OR OTHER
            MATERIALS TO THE SITE.
        </p>
        <p>
            MICROSTRATEGY RESERVES THE RIGHT TO MAKE CHANGES OR UPDATES TO THE
            SITE AT ANY TIME WITHOUT NOTICE.
        </p>
        <p>
            MICROSTRATEGY ASSUMES NO RESPONSIBILITY FOR ERRORS OR OMISSIONS IN
            THE INFORMATION OR SOFTWARE OR OTHER DOCUMENTS WHICH ARE REFERENCED
            BY OR LINKED TO THIS SITE.
        </p>
        <p>
            THIS SITE COULD INCLUDE TECHNICAL OR OTHER INACCURACIES. CHANGES ARE
            PERIODICALLY MADE TO THE INFORMATION HEREIN. HOWEVER, MICROSTRATEGY
            MAKES NO COMMITMENT TO UPDATE MATERIALS ON THIS SITE.
        </p>

        <h3 className="padding-top-30">LIMITATION OF LIABILITY</h3>
        <p>
            IN NO EVENT SHALL MICROSTRATEGY BE LIABLE FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES, OR DAMAGES FOR LOSS OF
            PROFITS, REVENUE, DATA OR USE, OR ANY OTHER DAMAGES OF ANY KIND,
            INCLUDING WITHOUT LIMITATION, THOSE RESULTING FROM: (1) RELIANCE ON
            THE MATERIALS PRESENTED, (2) DELAYS OR BUSINESS INTERRUPTIONS, OR
            (3) ANY THEORY OF LIABILITY, ARISING OUT OF OR IN CONNECTION WITH
            YOUR ACCESS TO, OR USE OF, THE SITE OR ANY CONTENT, MATERIALS,
            INFORMATION, SOFTWARE, PRODUCTS OR SERVICES PROVIDED ON THE SITE,
            WHETHER OR NOT MICROSTRATEGY HAS BEEN ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGES.
        </p>
        <p>
            SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF
            LIABILITY. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY
            TO YOU.
        </p>

        <h3 className="padding-top-30">INDEMNITY</h3>
        <p>
            You agree to defend, indemnify and hold harmless MicroStrategy, its
            officers, directors, employees and agents from and against any and
            all claims, liabilities, damages, losses or expenses, including
            reasonable attorneys" fees and costs, arising out of or in any way
            connected with your access to or use of the Site.
        </p>

        <h3 className="padding-top-30">PRIVACY POLICY</h3>
        <p>
            MicroStrategy is concerned about your privacy and has developed a
            policy to address privacy concerns. You can find the current privacy
            policy at{' '}
            <a href="/legal/privacy-policy">
                https://www.microstrategy.com/legal/privacy-policy
            </a>
            .
        </p>
        <h3 className="padding-top-30">NOTE ABOUT CHILDREN</h3>
        <p>
            Children under the age of 13 are not eligible to use the Site, and
            we ask that they do not submit any personal information to us.
        </p>
        <h3 className="padding-top-30">APPLICABLE LAWS</h3>
        <p>
            The Site is operated by MicroStrategy Incorporated from its offices
            in the United States of America. MicroStrategy makes no
            representation that the information located on the Site is
            appropriate or available for use in other locations, and access to
            the Site from territories where the content of the Site may be
            illegal is prohibited. Those who choose to access the Site from
            other locations do so on their own initiative and are responsible
            for compliance with applicable local laws. These Terms of Use are
            void where prohibited by law and the right to access the Site is
            revoked in such jurisdictions. You agree that if you become a
            resident in such a jurisdiction, you will immediately cease to
            access the Site. All matters relating to your access to, and use of,
            the Site shall be governed by U.S. federal law or the laws of the
            Commonwealth of Virginia, USA. Any legal action or proceeding
            relating to your access to, or use of, the Site shall be instituted
            in a state or federal court in Fairfax County, Virginia, USA. You
            and MicroStrategy agree to submit to the jurisdiction of, and agree
            that venue is proper in, these courts in any such legal action or
            proceeding.
        </p>

        <h3 className="padding-top-30">EXPORT CONTROL</h3>
        <p>
            You may not access, download, use or export any Site content or use
            or access the Site in violation of any country"s export control laws
            or regulations or any other applicable laws or regulations. You
            agree to comply with all export control laws and restrictions and
            regulations of the United States and/or any foreign agency or
            authority (as relevant), and not to directly or indirectly provide
            or otherwise make available the services and products of
            MicroStrategy in violation of any such restrictions, laws or
            regulations, or without all necessary approvals. As applicable, you
            shall obtain and bear all expenses relating to any necessary
            licenses and/or exemptions with respect to your own use of the Site
            outside the U.S or relevant jurisdiction. You shall not make the
            services or products of MicroStrategy nor the underlying information
            or technology available for download or otherwise provide, either
            directly or indirectly, (i) into any country subject to relevant
            export restrictions (including but not limited to those of the U.S.
            and E.U.), to individuals or entities controlled by such countries,
            or to nationals or residents of such countries other than nationals
            who are lawfully admitted permanent residents of countries not
            subject to such sanctions; or (ii) to anyone on the U.S. Treasury
            Department"s list of Specially Designated Nationals and Blocked
            Persons, the U.S. Commerce Department"s Denied Persons List, or the
            Consolidated List of the EU. By agreeing to these Terms of Use, you
            agree to the foregoing and represent and warrant that you are not on
            any of the aforementioned lists or located in, or under the control
            of, any country subject to export restrictions.
        </p>

        <h3 className="padding-top-30">
            MEMBER ACCOUNT, PASSWORD, AND SECURITY
        </h3>
        <p>
            If any of the Site features requires you to open an account, you
            must complete the registration process by providing us with current,
            complete and accurate information as prompted by the applicable
            registration form. You also will choose a password and a user name.
            You are entirely responsible for maintaining the confidentiality of
            your password and account. Furthermore, you are entirely responsible
            for any and all activities that occur under your account. You agree
            to notify MicroStrategy immediately of any unauthorized use of your
            account or any other breach of security. MicroStrategy will not be
            liable for any loss that you may incur as a result of someone else
            using your password or account, either with or without your
            knowledge. However, you could be held liable for losses incurred by
            MicroStrategy or another party due to someone else using your
            account or password. You may not use anyone else"s account at any
            time, without the permission of the account holder. MicroStrategy
            reserves the right to refuse access to certain areas of the Site to
            anyone, at any time, without notice, and for any reason.{' '}
        </p>

        <h3 className="padding-top-30">
            USE OF MATERIALS AVAILABLE ON THIS SITE
        </h3>
        <p>
            <strong>MicroStrategy Content</strong>
        </p>
        <p>
            Any software that is made available to download from the Site
            ("Software") is the copyrighted work of MicroStrategy. Use of the
            Software is governed by the terms of the license agreement which
            accompanies or is included with the Software ("License Agreement").
            An end user will be unable to install any Software that is
            accompanied by or includes a License Agreement, unless he or she
            first agrees to the License Agreement terms. Third party scripts or
            code, linked to or referenced from this website, are licensed to you
            by the third parties that own such code, not by MicroStrategy.{' '}
        </p>

        <p>
            The Software is made available for download solely for use by end
            users according to the License Agreement. Any reproduction or
            redistribution of the Software not in accordance with the License
            Agreement is expressly prohibited by law and may result in severe
            civil and criminal penalties. Violators will be prosecuted to the
            maximum extent possible.
        </p>
        <p>
            You may not modify, copy, distribute, transmit, display, perform,
            reproduce, publish, license, create derivative works from, transfer,
            or sell any MicroStrategy content obtained from the Site, in whole
            or in part without the express written authorization of
            MicroStrategy.{' '}
        </p>
        <p>
            Permission to use documents (such as white papers, press releases,
            datasheets, dashboards, visualizations, and FAQs) from the Site is
            granted, provided that (1) the below copyright notice appears in all
            copies and that both the copyright notice and this permission notice
            appear, (2) use of such documents from the Site is for informational
            and non-commercial or personal use only and will not be copied or
            posted on any network computer or broadcast in any media, and (3) no
            modifications of any documents are made. Accredited educational
            institutions, such as K-12, universities, private/public colleges,
            and state community colleges, may download and reproduce the
            documents for distribution in the classroom. Distribution outside
            the classroom requires express written permission. Use for any other
            purpose is expressly prohibited by law, and may result in severe
            civil and criminal penalties. Violators will be prosecuted to the
            maximum extent possible.{' '}
        </p>
        <p>
            WITHOUT LIMITING THE FOREGOING, COPYING OR REPRODUCTION OF THE
            SOFTWARE TO ANY OTHER SERVER OR LOCATION FOR FURTHER REPRODUCTION OR
            REDISTRIBUTION IS EXPRESSLY PROHIBITED, UNLESS SUCH REPRODUCTION OR
            REDISTRIBUTION IS EXPRESSLY PERMITTED BY THE LICENSE AGREEMENT
            ACCOMPANYING SUCH SOFTWARE.
        </p>
        <p>
            THE SOFTWARE IS WARRANTED, IF AT ALL, ONLY ACCORDING TO THE TERMS OF
            THE LICENSE AGREEMENT. EXCEPT AS WARRANTED IN THE LICENSE AGREEMENT,
            MICROSTRATEGY HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS WITH
            REGARD TO THE SOFTWARE, INCLUDING ALL WARRANTIES AND CONDITIONS OF
            MERCHANTABILITY, WHETHER EXPRESS, IMPLIED OR STATUTORY, FITNESS FOR
            A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT. FOR YOUR
            CONVENIENCE, MICROSTRATEGY MAY MAKE AVAILABLE AS PART OF THE SITE OR
            IN ITS SOFTWARE PRODUCTS, TOOLS AND UTILITIES FOR USE AND/OR
            DOWNLOAD. MICROSTRATEGY DOES NOT MAKE ANY ASSURANCES WITH REGARD TO
            THE ACCURACY OF THE RESULTS OR OUTPUT THAT DERIVES FROM SUCH USE OF
            ANY SUCH TOOLS AND UTILITIES. PLEASE RESPECT THE INTELLECTUAL
            PROPERTY RIGHTS OF OTHERS WHEN USING THE TOOLS AND UTILITIES MADE
            AVAILABLE ON THE SOFTWARE OR IN MICROSTRATEGY SITE PRODUCTS.
        </p>
        <p>
            <em>Government End Users</em>. Any Technical Data (as defined
            below), Software, products, or user documentation normally
            distributed or made available as part of the Software or products
            (“Documentation”) which is downloaded from the Site or provided to
            you under a License Agreement for or on behalf of the United States
            of America, its agencies and/or instrumentalities ("U.S.
            Government"), or for any other entity seeking or applying rights
            similar to those customarily claimed by the U.S. Government, is
            provided to you only as a “Commercial Item” as that term is defined
            in the U.S. Code of Federal Regulations (see 48 C.F.R. § 2.101). The
            rights MicroStrategy grants you to the Technical Data, Software,
            products, and Documentation are the same as the rights MicroStrategy
            grants to all other users of the Technical Data, Software, products,
            and Documentation consistent with (1) 48 C.F.R. § 12.211 and 48
            C.F.R. § 12.212 (for civilian acquisitions); and (2) 48 C.F.R. §
            252.227-7015 and 48 C.F.R. § 227.7202-3 (for U.S. Department of
            Defense acquisitions). The manufacturer of the Technical Data,
            Software, products, and Documentation is MicroStrategy Incorporated,
            1850 Towers Crescent Plaza Tysons Corner, VA 22182.{' '}
        </p>
        <p>
            Technical Data means recorded information, regardless of the form or
            method of recording, of a scientific or technical nature (including
            computer software documentation), as defined in 48 C.F.R. §
            252.227-7015. The term does not include computer software or data
            incidental to contract administration, such as financial and/or
            management information.
        </p>

        <p>
            <strong>User Content</strong>
        </p>
        <p>
            You acknowledge that you are responsible for any material you may
            post, submit or upload to or through the Site, including any
            materials that you post or upload to any Communication Services that
            are publicly accessible to users of the Site and any information you
            upload in connection with your use of our products, software or
            services made available via the Site (collectively, "User Content").
            Your responsibilities with respect to any User Content include
            ensuring its legality (including compliance with all applicable data
            privacy and protection laws), reliability, appropriateness,
            originality and copyright. For purposes of applicable privacy and
            data protection laws, you will be considered the data controller of
            all User Content and shall be solely liable in all respects for any
            infringement of the privacy and data protection rights of
            individuals whose data is included in your User Content. You may not
            upload to, distribute, grant access to or otherwise publish through
            the Communication Services any User Content that (i) is
            confidential, proprietary, false, fraudulent, libelous, defamatory,
            obscene, threatening, invasive of privacy or publicity rights,
            infringing on intellectual property rights, abusive, illegal or
            otherwise objectionable; (ii) may constitute or encourage a criminal
            offense, violate the rights of any third party or otherwise give
            rise to liability or violate any law or (iii) may contain software
            viruses, political campaigning, chain letters, mass mailings, or any
            form of "spam." You may not use a false email address or other
            identifying information, impersonate any person or entity or
            otherwise mislead as to the origin of any User Content. You may not
            upload commercial or business related content onto the Site.
        </p>
        <p>
            Unless agreed otherwise, you grant MicroStrategy and its affiliates
            an unrestricted, nonexclusive, royalty-free, perpetual, irrevocable
            and fully sublicensable right to use, reproduce, modify, adapt,
            publish, translate, create derivative works from, distribute and
            display User Content throughout the world in any media, subject in
            each case to the restrictions set forth in the Site"s Privacy
            Policy. You further agree that MicroStrategy and its affiliates are
            free to use any ideas, concepts, know-how that you or individuals
            acting on your behalf provide to MicroStrategy or its affiliates. No
            compensation will be paid with respect to the use of your User
            Content, as provided herein. MicroStrategy is under no obligation to
            post or use any User Content you may provide and MicroStrategy may
            remove any User Content at any time for legitimate reasons.
        </p>
        <p>
            By posting or uploading User Content you represent and warrant that
            you own or are authorized to exercise all of the rights to the User
            Content including, without limitation, all the rights necessary for
            you to provide, post, upload, input or submit the User Content; that
            User Content is accurate and up to date; that posting, submitting or
            uploading to or through the Site does not violate any provision
            herein and will not cause injury to any person or entity; and that
            you will indemnify MicroStrategy and its affiliates for all third
            party claims resulting from User Content.
        </p>
        <h3 className="padding-top-30">LINKING POLICY</h3>
        <p>
            Unless otherwise set forth in a written agreement between you and
            MicroStrategy, you must adhere to MicroStrategy"s linking policy as
            follows: (i) any link to the Site must be a text only link clearly
            marked "https://www.microstrategy.com," (ii) the appearance,
            position and other aspects of the link may not be such as to damage
            or dilute the goodwill associated with MicroStrategy"s names and
            trademarks, (iii) the link must "point" to the URL
            https://www.microstrategy.com and not to other pages within the
            Site, (iv) the appearance, position and other attributes of the link
            may not create the false appearance that your organization or entity
            is sponsored by, affiliated with, or associated with MicroStrategy,
            (v) when selected by a user, the link must display the Site on a
            full-screen and not within a "frame" on the linking Web site, and
            (vi) MicroStrategy reserves the right to revoke its consent to the
            link at any time and in its sole discretion.
        </p>

        <h3 className="padding-top-30">
            PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT INFRINGEMENT
        </h3>
        <p>
            ALL INQUIRIES NOT RELEVANT TO THE FOLLOWING PROCEDURE WILL NOT
            RECEIVE A RESPONSE.
        </p>
        <p>
            MicroStrategy and its affiliates respect the intellectual property
            rights of others, and we ask our users to do the same. Pursuant to
            Title 17, United States Code, Section 512(c)(2), if you believe that
            your copyrighted work has been copied and is accessible on a
            MicroStrategy Web site in a way that constitutes copyright
            infringement, please send a Notice to our Copyright Agent providing
            the following information:
        </p>
        <ol>
            <li>
                The electronic or physical signature of the owner of the
                copyright or the person authorized to act on the owner"s behalf
            </li>
            <li>
                A description of the copyrighted work that you claim has been
                infringed and a description of the infringing activity;
            </li>
            <li>
                A description of where the material that you claim is infringing
                is located, such as the URL where it is posted;
            </li>
            <li>Your name, address, telephone number, and email address;</li>
            <li>
                A statement by you that you have a good faith belief that the
                disputed use of the material is not authorized by the copyright
                owner, its agent, or the law; and
            </li>
            <li>
                A statement by you, made under penalty of perjury, that the
                above information in your Notice is accurate and that you are
                the copyright owner or are authorized to act on the copyright
                owner"s behalf.
            </li>
        </ol>
        <p>
            MicroStrategy"s Copyright Agent for Notice of claims of copyright
            infringement can be reached as follows:
        </p>

        <p className="padding-top-10">
            <strong>By mail:</strong>
        </p>
        <p>
            General Counsel <br />
            >MicroStrategy Incorporated
            <br /> 1850 Towers Crescent Plaza
            <br /> Tysons Corner, VA 22182
            <br />
        </p>

        <p className="padding-top-10">
            <strong>By telephone:</strong> 703-848-8600
        </p>

        <p className="padding-top-10">
            <strong>By fax:</strong> 703-832-1313
        </p>

        <p className="padding-top-10">
            <strong>By email:</strong>{' '}
            <a href="mailto:DMCA@microstrategy.com">DMCA@microstrategy.com</a>
        </p>

        <p className="padding-top-10">
            Please note: This contact information is solely for reporting
            copyright infringement.
        </p>

        <h3 className="padding-top-30">COPYRIGHT INFORMATION</h3>
        <p>
            All Contents Copyright © 2019 MicroStrategy Incorporated. All Rights
            Reserved.
        </p>
        <h3 className="padding-top-30">TRADEMARK INFORMATION</h3>
        <p>
            The following are either trademarks or registered trademarks of
            MicroStrategy Incorporated or its affiliates in the United States
            and certain other countries:{' '}
        </p>
        <p>
            MicroStrategy, MicroStrategy 2019, MicroStrategy 11, MicroStrategy
            10, MicroStrategy 10 Secure Enterprise, MicroStrategy 9,
            MicroStrategy 9s, MicroStrategy Analytics, MicroStrategy Analytics
            Platform, MicroStrategy Desktop, MicroStrategy Library,
            MicroStrategy Operations Manager, MicroStrategy Analytics
            Enterprise, MicroStrategy Evaluation Edition, MicroStrategy Secure
            Enterprise, MicroStrategy Web, MicroStrategy Mobile, MicroStrategy
            Server, MicroStrategy Parallel Relational In-Memory Engine
            (MicroStrategy PRIME), MicroStrategy MultiSource, MicroStrategy OLAP
            Services, MicroStrategy Intelligence Server, MicroStrategy
            Intelligence Server Universal, MicroStrategy Distribution Services,
            MicroStrategy Report Services, MicroStrategy Transaction Services,
            MicroStrategy Visual Insight, MicroStrategy Web Reporter,
            MicroStrategy Web Analyst, MicroStrategy Office, MicroStrategy Data
            Mining Services, MicroStrategy Geospatial Services, MicroStrategy
            Narrowcast Server, MicroStrategy Health Center, MicroStrategy
            Analyst, MicroStrategy Developer, MicroStrategy Web Professional,
            MicroStrategy Architect, MicroStrategy SDK, MicroStrategy Command
            Manager, MicroStrategy Enterprise Manager, MicroStrategy Object
            Manager, MicroStrategy Integrity Manager, MicroStrategy System
            Manager, MicroStrategy Analytics App, MicroStrategy Mobile App,
            MicroStrategy Tech Support App, MicroStrategy Mobile App Platform,
            MicroStrategy Cloud, MicroStrategy R Integration, Dossier, Usher,
            MicroStrategy Usher, Usher Badge, Usher Security, Usher Security
            Server, Usher Mobile, Usher Analytics, Usher Network Manager, Usher
            Professional, MicroStrategy Identity, MicroStrategy Badge,
            MicroStrategy Identity Server, MicroStrategy Identity Analytics,
            MicroStrategy Identity Manager, MicroStrategy Communicator,
            MicroStrategy Services, MicroStrategy Professional Services,
            MicroStrategy Consulting, MicroStrategy Customer Services,
            MicroStrategy Education, MicroStrategy University, MicroStrategy
            Managed Services, BI QuickStrike, Mobile QuickStrike, Transaction
            Services QuickStrike Perennial Education Pass, MicroStrategy Web
            Based Training (WBT), MicroStrategy World, Best in Business
            Intelligence, Pixel Perfect, Global Delivery Center, Direct Connect,
            Enterprise Grade Security For Every Business, Build Your Own
            Business Apps, Code-Free, Welcome to Ideal, Intelligent Enterprise,
            HyperIntelligence, HyperCard, HyperVoice, HyperVision, HyperMobile,
            Zero-Click Intelligence, Enterprise Semantic Graph, The World’s Most
            Comprehensive Analytics Platform, The World’s Most Comprehensive
            Analytics Platform. Period.
        </p>
        <p>
            Other product and company names mentioned herein may be the
            trademarks of their respective owners.{' '}
        </p>
        <p>
            Specifications subject to change without notice. MicroStrategy is
            not responsible for errors or omissions. MicroStrategy makes no
            warranties or commitments concerning the availability of future
            products or versions that may be planned or under development.
        </p>

        <h3 className="padding-top-30">UNSOLICITED IDEA SUBMISSION POLICY</h3>
        <p>
            MICROSTRATEGY OR ANY OF ITS EMPLOYEES DO NOT ACCEPT OR CONSIDER
            UNSOLICITED IDEAS, INCLUDING IDEAS FOR NEW ADVERTISING CAMPAIGNS,
            NEW PROMOTIONS, NEW PRODUCTS OR TECHNOLOGIES, PROCESSES, MATERIALS,
            MARKETING PLANS OR NEW PRODUCT NAMES. PLEASE DO NOT SEND ANY
            ORIGINAL CREATIVE ARTWORK, SAMPLES, DEMOS, OR OTHER WORKS. THE SOLE
            PURPOSE OF THIS POLICY IS TO AVOID POTENTIAL MISUNDERSTANDINGS OR
            DISPUTES WHEN MICROSTRATEGY"S PRODUCTS OR MARKETING STRATEGIES MIGHT
            SEEM SIMILAR TO IDEAS SUBMITTED TO MICROSTRATEGY. SO, PLEASE DO NOT
            SEND YOUR UNSOLICITED IDEAS TO MICROSTRATEGY OR ANYONE AT
            MICROSTRATEGY. IF, DESPITE OUR REQUEST THAT YOU NOT SEND US YOUR
            IDEAS AND MATERIALS, YOU STILL SEND THEM, PLEASE UNDERSTAND THAT
            MICROSTRATEGY MAKES NO ASSURANCES THAT YOUR IDEAS AND MATERIALS WILL
            BE TREATED AS CONFIDENTIAL OR PROPRIETARY.
        </p>
    </div>
);

export default licenseAgreementContent;